import React from "react";
import { USER_BADGE } from "../utils/enums";

interface UserBadgeProps {
  badge: string;
  size?: "small" | "large";
}

interface BadgeConfig {
  label: string;
  icon: string; // Bootstrap icon class, e.g. "bi-patch-check-fill"
}

const BADGE_CONFIG: Record<string, BadgeConfig> = {
  [USER_BADGE.VERIFIED]: {
    label: "Verified",
    icon: "bi-patch-check-fill",
  },
  [USER_BADGE.ESTABLISHED]: {
    label: "Established",
    icon: "bi-award-fill",
  },
  [USER_BADGE.FOUNDING_MEMBER]: {
    label: "Founding Member",
    icon: "bi-stars",
  },
};

// Renders any user badge (Verified / Established / Founding Member) as the
// same pill-shaped primary-green chip with an icon. Unknown badge values
// render nothing.
const UserBadge: React.FC<UserBadgeProps> = ({ badge, size = "large" }) => {
  const config = BADGE_CONFIG[badge];
  if (!config) return null;
  const isSmall = size === "small";

  return (
    <div
      className={`verifiedBadge ${
        isSmall ? "verifiedBadge--small" : "verifiedBadge--large"
      }`}
    >
      <i
        className={`bi ${config.icon} verifiedBadge__icon ${
          isSmall ? "verifiedBadge__icon--small" : "verifiedBadge__icon--large"
        }`}
        aria-hidden="true"
      ></i>
      <span>{config.label}</span>
    </div>
  );
};

export default UserBadge;
